import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Container } from './style'
import {
  selectShowAskNameDialog,
  selectAskNameDialogTitle,
  selectAskNameDialogFromScheduled,
  setShowAskNameDialog,
} from '../../reducers/uiSlice'
import { JoinChatForm } from '../Chat/JoinChatForm'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

const AskNameDialog = () => {
  const dispatch = useDispatch()
  const askNameDialogIsVisible = useSelector(selectShowAskNameDialog)
  const title = useSelector(selectAskNameDialogTitle)
  const fromScheduled = useSelector(selectAskNameDialogFromScheduled)

  const handleClose = () => {
    dispatch(setShowAskNameDialog({ open: false }))
  }

  return (
    <Container data-test="askName-container" open={askNameDialogIsVisible ?? false}>
      <IconButton
        onClick={handleClose}
        style={{ position: 'absolute', top: 8, right: 8 }}
        size="small"
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <JoinChatForm isDesktop title={title} fromScheduled={fromScheduled} />
    </Container>
  )
}

export default AskNameDialog
